import { LollipopBuffer } from './src/lollipop/types'

export function eventGroupByName(bufferEvents: LollipopBuffer[]): LollipopBuffer[] {
    const grouped = bufferEvents.reduce(function (obj, newdata) {
        obj[newdata.name] = obj[newdata.name] || []
        obj[newdata.name].push(...newdata.data)

        return obj
    }, {})

    const groups = Object.keys(grouped).map(function (key) {
        const found = bufferEvents.find(element => {
            if (key === element.name) {
                return element.color
            }
        })

        const foundMarker = bufferEvents.find(element => {
            if (key === element.name) {
                return element.marker
            }
        })

        return { name: key, data: grouped[key], color: found?.color, marker: foundMarker.marker }
    })

    return groups
}

export function mergeEvents(oldData: LollipopBuffer[], data: LollipopBuffer[]): LollipopBuffer[] {
    const newdata = []

    oldData.forEach(dataItem => {
        const hasEvent = data.find(event => event.name === dataItem.name)
        if (!hasEvent) {
            newdata.push(dataItem)
        }
    })

    data.forEach(lollipop => {
        const hasLollipop = oldData.find(element => lollipop.name === element.name)
        if (hasLollipop) {
            const lollipopTemp = {
                ...hasLollipop,
                data: [...hasLollipop.data, ...lollipop.data],
                color: lollipop.color,
                marker: lollipop.marker
            }
            newdata.push(lollipopTemp)

            return
        }
        newdata.push(lollipop)
    })

    return newdata
}

export function crop(
    arr: [number, number][],
    begin: number,
    end: number = Number.MAX_SAFE_INTEGER
): [number, number][] {
    if (arr.length > 0 && begin < end) {
        let cropStart = 0
        let cropEnd = arr.length - 1

        // Special case for when there is only one item in the list
        if (arr[cropEnd][0] < begin || arr[0][0] > end) {
            return []
        }

        while (cropStart < cropEnd && arr[cropStart][0] < begin) {
            cropStart++
        }

        while (cropStart < cropEnd && arr[cropEnd][0] > end) {
            cropEnd--
        }

        if (cropEnd === cropStart) {
            return [arr[cropEnd]]
        }

        if (cropStart > 0 || cropEnd < arr.length - 1) {
            return arr.slice(cropStart, cropEnd + 1)
        }
    }

    return arr
}
